/**
 * @fileoverview Query key of the signed-in user's principal (identity + capabilities).
 * @description Lives in shared so both the feature that owns the query (features/auth's
 * useCurrentSession) and shared code that has to refresh it (the response interceptor, via
 * access-refresh.utils.ts) can name it without shared importing a feature (ADR-0002).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const CURRENT_SESSION_QUERY_KEY = ['identity', 'me']
